export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    align: 'center',
    width: 90,
    fixed: 'right',
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('form_label_fabric_color_no') || '面料颜色编号',
    field: 'fabricColorNo',
    minWidth: 190,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabricColorTitle') || '面料中文颜色',
    field: 'fabricColorTitle',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabricColorTitleEn') || '面料英文颜色',
    field: 'fabricColorTitleEn',
    minWidth: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_request_quantity') || '需求数量',
    field: 'requestQuantity',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_requestMetre') || '需求米数',
    field: 'requestMetre',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },{
    title: that.$l('table_label_isCustomerExclusiveColor') || '是否客户专属颜色',
    field: 'isCustomerExclusiveColorText',
    align: 'left',
    minWidth: 60,
  }
]
